import React from "react";

const Links = ({ links }) => {
    return (
        <div className="links">
            {links.map((link, index) => (
                <a key={index} href={link.url} target="_blank" rel="noopener noreferer" className="link-item">
                    {link.title}
                </a>
            ))}
        </div>
    );
};

export default Links;